module.exports = __webpack_public_path__ + "static/logo-04eaba16834343823e531f43d1673606.jpg";